<nh-spinner></nh-spinner>
@if (tccGetMobileAppSwitch && onHomeScreen && !isScrolledDown) {
  <div>
    <nh-smart-app-banner></nh-smart-app-banner>
  </div>
}
<!-- ARIA live region for page title announcements -->
<div id="page-announcer" 
     aria-live="polite" 
     aria-atomic="true" 
     class="visually-hidden">
</div>
@if (isMasterBannerSwitchEnabled && !bannerRevampSwitch) {
  <div>
    @if (!isPartner && isSiteWideAlertEnabled && enableBannerMessage() && mpMaintenanceBanner) {
      <nh-alert type="sitewide" [isOpen]="isMobileView">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
          </div>
          <div class="col message">
            <span [innerHTML]="siteWideText | globalTranslate"></span>
          </div>
        </div>
      </nh-alert>
    }
    @if (siteWideMasterSwitch && mpMaintenanceBanner) {
      <nh-alert type="sitewide" [isOpen]="isMobileView">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
          </div>
          <div class="col auto message">
            <span [innerHTML]="siteWideText | globalTranslate"></span>
          </div>
        </div>
      </nh-alert>
    }
    @if (!isPartner && !isLoggedIn() && enableBannerMessage() && renewalText) {
      <nh-alert type="sitewide" [isOpen]="isMobileView">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
          </div>
          <div class="col auto message">
            <span>{{renewalText | globalTranslate}}</span>
          </div>
        </div>
      </nh-alert>
    }
    @if ((isPPRenewalAlertEnabled || isPPDDARenewalAlertEnabled) && renewalPPText) {
      <nh-alert type="sitewide" [isOpen]="isMobileView">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
          </div>
          <div class="col auto message">
            <span>{{renewalPPText | globalTranslate}}</span>
          </div>
        </div>
      </nh-alert>
    }

    @if (isPPDentalBannerSwitchEnabled) {
      <nh-alert type="sitewide" [isOpen]="isMobileView">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
          </div>
          <div class="col auto message">
            <span [innerHTML]="dentalBenefitsPPText | globalTranslate"></span>
          </div>
        </div>
      </nh-alert>
    }

    @if (!isPartner && isDentalBannerSwitchEnabled && enableBannerMessage()) {
      <nh-alert type="sitewide" [isOpen]="isMobileView">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
          </div>
          <div class="col auto message">
            <span [innerHTML]="dentalBenefitsText | globalTranslate"></span>
          </div>
        </div>
      </nh-alert>
    }
  </div>
}
@if (isMasterBannerSwitchEnabled && bannerRevampSwitch) {
  <div>
    @if (activeMobileSitewideAlertKey) {
      <nh-alert type="sitewide2" [isOpen]="isMobileView">
        <div class="sitewide-banner-wrapper" [class.has-nav]="mobileSitewideAlertKeys.length > 1">
          @if (mobileSitewideAlertKeys.length > 1) {
            <span class="sitewide-alert-counter">
              {{ mobileSitewideAlertIndex + 1 }} {{ 'OF' | globalTranslate }} {{ mobileSitewideAlertKeys.length }}
            </span>
          }
          @if (mobileSitewideAlertKeys.length > 1) {
            <button
              type="button"
              class="sitewide-alert-nav-arrow sitewide-nav-left"
              (click)="previousMobileSitewideAlert()"
              [disabled]="mobileSitewideAlertIndex === 0"
              [attr.aria-label]="previousAlertAriaLabel | globalTranslate"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path d="M58,48A10,10,0,1,0,68,58,10,10,0,0,0,58,48Zm1.7,14.072a.769.769,0,1,1-1.088,1.088l-4.615-4.615a.769.769,0,0,1,0-1.087l4.615-4.615A.769.769,0,0,1,59.7,53.928L55.626,58Z" transform="translate(-48 -48)" fill="#1b365d"/>
              </svg>
            </button>
          }
          <div class="row sitewide-alert-content">
            <div class="col-auto icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="29" viewBox="0 0 26 29">
<g id="Group_1552" data-name="Group 1552" transform="translate(-42 -142)">
<path id="notifications-sharp" d="M76.5,57a5.307,5.307,0,0,0,4.772-2.679H71.728A5.307,5.307,0,0,0,76.5,57Zm9.375-10.714V42.908c0-3.932-1.781-7.358-6.25-8.229L79.1,32H73.9l-.521,2.679c-4.484.871-6.25,4.283-6.25,8.229v3.378L64,49.857v2.679H89V49.857Z" transform="translate(-22 114)" fill="#132742"/>
<path id="Path_532" data-name="Path 532" d="M53,48a5,5,0,1,0,5,5A5.006,5.006,0,0,0,53,48Zm.481,7.69h-.962v-.962h.962Zm-.1-1.536h-.769l-.144-3.846h1.058Z" transform="translate(10 94)" fill="#e91b1b"/>
</g>
</svg>
            </div>
            <div class="col-auto message" style="font-size: 16px;">
              @switch (activeMobileSitewideAlertKey) {
                @case ('siteWide') {
                  @if (showMobileSiteWideAlert()) {
                    <span
                      [innerHTML]="'<b class=&quot;sitewide-maintenance-label&quot;>' + (scheduledMaintenanceLabel | globalTranslate) + '</b><br>' + (siteWideText | globalTranslate)"
                    ></span>
                  }
                }
                @case ('siteWideMaster') {
                  @if (showMobileSiteWideMasterAlert()) {
                    <span
                      [innerHTML]="'<b class=&quot;sitewide-maintenance-label&quot;>' + (scheduledMaintenanceLabel | globalTranslate) + '</b><br>' + (siteWideText | globalTranslate)"
                    ></span>
                  }
                }
                @case ('renewal') {
                  @if (showMobileRenewalAlert()) {
                    <span>{{renewalText | globalTranslate}}</span>
                  }
                }
                @case ('renewalPP') {
                  @if (showMobileRenewalPPAlert()) {
                    <span>{{renewalPPText | globalTranslate}}</span>
                  }
                }
                @case ('dentalPP') {
                  @if (showMobileDentalPPAlert()) {
                    <span [innerHTML]="dentalBenefitsPPText | globalTranslate"></span>
                  }
                }
                @case ('dental') {
                  @if (showMobileDentalAlert()) {
                    <span [innerHTML]="dentalBenefitsText | globalTranslate"></span>
                  }
                }
              }
            </div>
          </div>
          @if (mobileSitewideAlertKeys.length > 1) {
            <div class="sitewide-alert-navigation">
              <span class="sitewide-alert-dots">
                @for (key of mobileSitewideAlertKeys; track key; let i = $index) {
                  <button
                    type="button"
                    class="sitewide-alert-dot"
                    [class.active]="i === mobileSitewideAlertIndex"
                    (click)="setMobileSitewideAlertIndex(i)"
                    [attr.aria-label]="'Alert ' + (i + 1)"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
                      <circle cx="4" cy="4" r="4" [attr.fill]="i === mobileSitewideAlertIndex ? '#1b365d' : '#ffffff'"/>
                    </svg>
                  </button>
                }
              </span>
              <span class="visually-hidden">Alert {{ mobileSitewideAlertIndex + 1 }} {{ 'OF' | globalTranslate }} {{ mobileSitewideAlertKeys.length }}</span>
            </div>
          }
          @if (mobileSitewideAlertKeys.length > 1) {
            <button
              type="button"
              class="sitewide-alert-nav-arrow sitewide-nav-right"
              (click)="nextMobileSitewideAlert()"
              [disabled]="mobileSitewideAlertIndex >= mobileSitewideAlertKeys.length - 1"
              [attr.aria-label]="nextAlertAriaLabel | globalTranslate"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" style="transform: scaleX(-1)">
                <path d="M58,48A10,10,0,1,0,68,58,10,10,0,0,0,58,48Zm1.7,14.072a.769.769,0,1,1-1.088,1.088l-4.615-4.615a.769.769,0,0,1,0-1.087l4.615-4.615A.769.769,0,0,1,59.7,53.928L55.626,58Z" transform="translate(-48 -48)" fill="#1b365d"/>
              </svg>
            </button>
          }
        </div>
      </nh-alert>
    }
  </div>
}
<mat-sidenav-container class="reset-height">
  <mat-sidenav-content  [class.sp]="translateService.getDefaultLang() === 'sp'">
    <nh-header (toggle)="onToggle($event)" (signout)="onSignout($event)"></nh-header>
      @if (isEnvironmentAlertEnabled) {
        <div class="env-message" role="complementary">{{environmentAlertText | globalTranslate}} - {{environmentName | globalTranslate}}</div>
      }
      @if (isMasterBannerSwitchEnabled && !bannerRevampSwitch) {
        <div>
          @if (!isPartner && isSiteWideAlertEnabled && enableBannerMessage() && mpMaintenanceBanner) {
            <nh-alert type="sitewide" [isOpen]="!isMobileView">
              <div class="row">
                <div class="col-auto icon">
                  <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
                </div>
                <div class="col auto message">
                  <span [innerHTML]="siteWideText | globalTranslate"></span>
                </div>
              </div>
            </nh-alert>
          }
          @if (siteWideMasterSwitch && mpMaintenanceBanner) {
            <nh-alert type="sitewide" [isOpen]="!isMobileView">
              <div class="row">
                <div class="col-auto icon">
                  <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
                </div>
                <div class="col auto message">
                  <span [innerHTML]="siteWideText | globalTranslate"></span>
                </div>
              </div>
            </nh-alert>
          }
          @if (!isPartner && !isLoggedIn() && enableBannerMessage() && renewalText) {
            <nh-alert type="sitewide" [isOpen]="!isMobileView">
              <div class="row">
                <div class="col-auto icon">
                  <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
                </div>
                <div class="col auto message">
                  <span>{{renewalText | globalTranslate}}</span>
                </div>
              </div>
            </nh-alert>
          }
          @if ((isPPRenewalAlertEnabled || isPPDDARenewalAlertEnabled) && renewalPPText) {
            <nh-alert type="sitewide" [isOpen]="!isMobileView">
              <div class="row">
                <div class="col-auto icon">
                  <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
                </div>
                <div class="col auto message">
                  <span>{{renewalPPText | globalTranslate}}</span>
                </div>
              </div>
            </nh-alert>
          }

          @if (isPPDentalBannerSwitchEnabled) {
            <nh-alert type="sitewide" [isOpen]="!isMobileView">
              <div class="row">
                <div class="col-auto icon">
                  <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
                </div>
                <div class="col auto message">
                  <span [innerHTML]="dentalBenefitsPPText | globalTranslate"></span>
                </div>
              </div>
            </nh-alert>
          }

          @if (!isPartner && !isLoggedIn() && isDentalBannerSwitchEnabled && enableBannerMessage()) {
            <nh-alert type="sitewide" [isOpen]="!isMobileView">
              <div class="row">
                <div class="col-auto icon">
                  <img src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline-white.svg" alt="warning" aria-hidden="true" role="presentation" />
                </div>
                <div class="col auto message">
                  <span [innerHTML]="dentalBenefitsText | globalTranslate"></span>
                </div>
              </div>
            </nh-alert>
          }
        </div>
      }
      @if (isMasterBannerSwitchEnabled && bannerRevampSwitch) {
        <div>
      @if (activeDesktopSitewideAlertKey) {
      <nh-alert type="sitewide2" [isOpen]="!isMobileView">
        <div class="sitewide-banner-wrapper" [class.has-nav]="desktopSitewideAlertKeys.length > 1">
          @if (desktopSitewideAlertKeys.length > 1) {
            <span class="sitewide-alert-counter">
              {{ desktopSitewideAlertIndex + 1 }} {{ 'OF' | globalTranslate }} {{ desktopSitewideAlertKeys.length }}
            </span>
          }
          @if (desktopSitewideAlertKeys.length > 1) {
            <button
              type="button"
              class="sitewide-alert-nav-arrow sitewide-nav-left"
              (click)="previousDesktopSitewideAlert()"
              [disabled]="desktopSitewideAlertIndex === 0"
              [attr.aria-label]="previousAlertAriaLabel | globalTranslate"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path d="M58,48A10,10,0,1,0,68,58,10,10,0,0,0,58,48Zm1.7,14.072a.769.769,0,1,1-1.088,1.088l-4.615-4.615a.769.769,0,0,1,0-1.087l4.615-4.615A.769.769,0,0,1,59.7,53.928L55.626,58Z" transform="translate(-48 -48)" fill="#1b365d"/>
              </svg>
            </button>
          }
          <div class="row sitewide-alert-content">
            <div class="col-auto icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="29" viewBox="0 0 26 29">
<g id="Group_1552" data-name="Group 1552" transform="translate(-42 -142)">
<path id="notifications-sharp" d="M76.5,57a5.307,5.307,0,0,0,4.772-2.679H71.728A5.307,5.307,0,0,0,76.5,57Zm9.375-10.714V42.908c0-3.932-1.781-7.358-6.25-8.229L79.1,32H73.9l-.521,2.679c-4.484.871-6.25,4.283-6.25,8.229v3.378L64,49.857v2.679H89V49.857Z" transform="translate(-22 114)" fill="#132742"/>
<path id="Path_532" data-name="Path 532" d="M53,48a5,5,0,1,0,5,5A5.006,5.006,0,0,0,53,48Zm.481,7.69h-.962v-.962h.962Zm-.1-1.536h-.769l-.144-3.846h1.058Z" transform="translate(10 94)" fill="#e91b1b"/>
</g>
</svg>
            </div>
            <div class="col-auto message">
              @switch (activeDesktopSitewideAlertKey) {
                @case ('siteWide') {
                  @if (showDesktopSiteWideAlert()) {
                    <span
                      [innerHTML]="'<b class=&quot;sitewide-maintenance-label&quot;>' + (scheduledMaintenanceLabel | globalTranslate) + '</b><br>' + (siteWideText | globalTranslate)"
                    ></span>
                  }
                }
                @case ('siteWideMaster') {
                  @if (showDesktopSiteWideMasterAlert()) {
                    <span
                      [innerHTML]="'<b class=&quot;sitewide-maintenance-label&quot;>' + (scheduledMaintenanceLabel | globalTranslate) + '</b><br>' + (siteWideText | globalTranslate)"
                    ></span>
                  }
                }
                @case ('renewal') {
                  @if (showDesktopRenewalAlert()) {
                    <span>{{renewalText | globalTranslate}}</span>
                  }
                }
                @case ('renewalPP') {
                  @if (showDesktopRenewalPPAlert()) {
                    <span>{{renewalPPText | globalTranslate}}</span>
                  }
                }
                @case ('dentalPP') {
                  @if (showDesktopDentalPPAlert()) {
                    <span [innerHTML]="dentalBenefitsPPText | globalTranslate"></span>
                  }
                }
                @case ('dental') {
                  @if (showDesktopDentalAlert()) {
                    <span [innerHTML]="dentalBenefitsText | globalTranslate"></span>
                  }
                }
              }
            </div>
          </div>
          @if (desktopSitewideAlertKeys.length > 1) {
            <div class="sitewide-alert-navigation">
              <span class="sitewide-alert-dots">
                @for (key of desktopSitewideAlertKeys; track key; let i = $index) {
                  <button
                    type="button"
                    class="sitewide-alert-dot"
                    [class.active]="i === desktopSitewideAlertIndex"
                    (click)="setDesktopSitewideAlertIndex(i)"
                    [attr.aria-label]="'Alert ' + (i + 1)"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
                      <circle cx="4" cy="4" r="4" [attr.fill]="i === desktopSitewideAlertIndex ? '#1b365d' : '#ffffff'"/>
                    </svg>
                  </button>
                }
              </span>
              <span class="visually-hidden">Alert {{ desktopSitewideAlertIndex + 1 }} {{ 'OF' | globalTranslate }} {{ desktopSitewideAlertKeys.length }}</span>
            </div>
          }
          @if (desktopSitewideAlertKeys.length > 1) {
            <button
              type="button"
              class="sitewide-alert-nav-arrow sitewide-nav-right"
              (click)="nextDesktopSitewideAlert()"
              [disabled]="desktopSitewideAlertIndex >= desktopSitewideAlertKeys.length - 1"
              [attr.aria-label]="nextAlertAriaLabel | globalTranslate"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" style="transform: scaleX(-1)">
                <path d="M58,48A10,10,0,1,0,68,58,10,10,0,0,0,58,48Zm1.7,14.072a.769.769,0,1,1-1.088,1.088l-4.615-4.615a.769.769,0,0,1,0-1.087l4.615-4.615A.769.769,0,0,1,59.7,53.928L55.626,58Z" transform="translate(-48 -48)" fill="#1b365d"/>
              </svg>
            </button>
          }
        </div>
      </nh-alert>
    }
    </div>
    }
    @if (isOnApp) {
    <div class="bg-white mgn-tp">
      <div class="container d-lg-none">
        <div>
          <div class="sub-text-prog">{{'TRACKER' |  globalTranslate}}</div>
          <div class="app-tracker row">
            <div class="col-10" (click)="onProgressBarOpen()">
              @switch (appType) {
                @case ('APL') {
                  <strong>{{'APPEAL_PROGRESS' | globalTranslate}}</strong>
                }
                @case ('MEDICAL_APPEAL') {
                  <strong>{{'MEDICAL_APPEAL_PROGRESS' | globalTranslate}}</strong>
                }
                @default {
                  <strong>{{'APPLICATION_PROGRESS' | globalTranslate}}</strong>
                }
              }
            </div>
            <div class="col-2 arrow-style">
              @if (!isMobileProgBarOpen) {
                <img (click)="onProgressBarOpen()" src="../assets/images/⚛️ icons-caret-down-outline.svg" alt="collapsed">
              }
              @if (isMobileProgBarOpen) {
                <img (click)="onProgressBarOpen()" src="../assets/images/⚛️ icons-caret-up-outline.svg" alt="expanded">
              }
            </div>
          </div>
          <br />
        </div>
        <div class="mobile-progress-bar container">
          @if (isMobileProgBarOpen) {
            <nh-stepper class="d-lg-none"></nh-stepper>
          }
        </div>
      </div>
    </div>
    }
    <div [ngClass]="{'container': isOnApp}" role="main" id="main-content" aria-label="Main content area">
      <nh-notifications [messages]="notifications"></nh-notifications>
      @if (isOnApp) {
        <nh-stepper class="d-none d-lg-block"></nh-stepper>
      }
      @if (isOnApp && !isSecondTitle()) {
        <nh-page-title [title]="title$ | async " [isSummary]="isSummaryNew$" [isSubTitleEnabled]="isSubTitleEnabled$ | async"></nh-page-title>
      }
      @if (isOnApp && isSecondTitle()) {
        <nh-page-title [title]="secondTitle$ | async "  [isSummary]="isSummaryNew$"></nh-page-title>
      }
      <nh-chatbot></nh-chatbot>
      <router-outlet (activate)="onActivate()"></router-outlet>
    </div>
    @if (!mobileUser) {
      <nh-footer></nh-footer>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
@if (isMobileView) {
  <nh-scroll-top></nh-scroll-top>
}